Shopify.queryParams = {};

// Preserve existing query parameters
if (location.search.length) {
  var params = location.search.substr(1).split('&');

  for (var i = 0; i < params.length; i++) {
    var keyValue = params[i].split('=');

    if (keyValue.length) {
      Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
    }
  }
}

// Update sort_by query parameter on select change
document.querySelector('#sort-by').addEventListener('change', function(e) {
  var value = e.target.value;

  Shopify.queryParams.sort_by = value;
  location.search = new URLSearchParams(Shopify.queryParams).toString();
});

      // FUNCTION FOR CHANGE OF SELECT SORT BY TO CHANGE THE WIDTH OF THE ELEMENT
      // var select = document.getElementById("sort-by");
      
      // switch (select.selectedIndex) {
      //   case 0:
      //     select.style.width = "80px";
      //     break;
      //   case 1:
      //     select.style.width = "90px";
      //     break;
      //     case 2:
      //       select.style.width = "115px";
      //       break;
      //   default:
      //     break;
      // }
      